import React from 'react';

const GamesCollectionSection = ({ games }) => {
  return (
    <section aria-labelledby="games-list-title" className="mb-20">
      <div className="max-w-2xl mx-auto text-center">
        <h2
          id="games-list-title"
          className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
        >
          Colecao atual
        </h2>
        <p className="mt-4 text-lg text-gray-600">
          Jogos autorais em JavaScript, combinando Canvas e DOM com regras proprias, progressao de
          dificuldade e placares locais/online.
        </p>
      </div>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {games.map((game) => (
          <article
            key={game.id}
            className="bg-gradient-to-br from-slate-50 via-white to-blue-50 rounded-xl border border-slate-200 shadow-lg site-card shadow-slate-200/70 overflow-hidden flex flex-col transition hover:-translate-y-0.5 hover:shadow-xl hover:shadow-slate-200/80"
          >
            <div className="p-6 flex-grow">
              <div className="flex items-start justify-between gap-4">
                <h3 className="text-xl font-semibold text-gray-900">{game.title}</h3>
                <span className="inline-flex items-center rounded-full border border-slate-200 bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-700">
                  {game.status}
                </span>
              </div>
              <p className="mt-4 text-gray-600">{game.description}</p>
              <ul className="mt-4 space-y-2 text-sm text-gray-500">
                {game.details.map((detail) => (
                  <li key={`${game.id}-${detail}`}>{detail}</li>
                ))}
              </ul>
              <div className="mt-4 flex flex-wrap gap-2">
                {game.tags.map((tag) => (
                  <span
                    key={`${game.id}-${tag}`}
                    className="inline-flex items-center rounded-full border border-sky-200 bg-sky-100 px-2.5 py-0.5 text-xs font-semibold text-sky-700"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
            <div className="border-t border-slate-200 bg-slate-100/70 p-4 site-card-strip flex items-center justify-between">
              <a
                href={game.href}
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-sky-700 hover:text-sky-800 hover:underline"
              >
                Abrir jogo
              </a>
              <span className="text-xs text-slate-500">Nova aba</span>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default GamesCollectionSection;
